import i18n from '../../../../../../i18n'
import {
  getTestVariablesRecipientId,
  getTestVariablesReportItemId,
} from '../useTestVariables.utils'

function getRecipientName(reportItem, recipients) {
  return reportItem.external
    ? i18n.t('Email.EmailVariablesReportAllRecipientsKey')
    : recipients.find(
        recipient =>
          getTestVariablesRecipientId(recipient) === reportItem.recipient
      )?.fullname || reportItem.email
}

function hasTemplateReportMissingVariables(templateReport) {
  return templateReport.report?.length > 0
}

function isSameReportItemRecipient(reportItem, deletedReportItem) {
  return (
    (Boolean(reportItem.recipient) &&
      reportItem.recipient === deletedReportItem.recipient) ||
    (Boolean(reportItem.email) && reportItem.email === deletedReportItem.email)
  )
}

function excludeReportRecipients(report, deletedReport) {
  return report.filter(
    reportItem =>
      !deletedReport.some(deletedReportItem =>
        isSameReportItemRecipient(reportItem, deletedReportItem)
      )
  )
}

export function parseReportRecipients(report, recipients) {
  return report.map(item => ({
    id: getTestVariablesReportItemId(item),
    recipient_name: getRecipientName(item, recipients),
    recipient_variable: item.variable,
  }))
}

export function getMissingVariablesTemplateReports(templateReports) {
  return templateReports.filter(hasTemplateReportMissingVariables)
}

export function excludeTemplateReportsRecipients({ report, templateReports }) {
  return templateReports
    .map(templateReport => ({
      ...templateReport,
      report: excludeReportRecipients(templateReport.report, report),
    }))
    .filter(hasTemplateReportMissingVariables)
}
